import { useRoute } from "@bcm-dev/bcms-vite";
import { Bill, Biller, Payment } from "model";
import { SVGAsset } from "res";
import BillerDetailsUpsellView from "../BillerDetailsUpsellView";

import "./styles.css";

export default function BillerDetailseBillUpsell(props) {
  const biller = props.biller ?? Biller.firstInstanceOf();
  const bill = props.bill;

  const navigate = useRoute();

  let showEbillPromo = biller.paymentType === "electronic" && bill.biller.eBillStatus === "Not Enrolled";
  const isVirtualCard = biller.paymentType === "virtualCard";
  if(isVirtualCard) showEbillPromo = false;
  const showActiveEBill = biller.eBillStatus === "Active";

  const billerName = biller.name;
  const billerNumber = biller.number;

  const payments = Payment.sortDateAscending(Payment.initAll()).filter(payment => payment.to.id === biller.id, []);
  // Filter bills that are not "paid". 
  // Paid bills will be shown under "Biller Activity" instead.
  const bills = Bill.sortDateAscending(Bill.initAll()).filter( bill => { 
    return bill.biller.id === biller.id && bill.status.toLowerCase() !== "paid"
  }, []);

  return(

    <div className="biller-details-ebill-upsell">
      { showEbillPromo && 
        <BillerDetailsUpsellView 
          icon={ <SVGAsset id="EbillsIcon" className="upsell-icon" /> } 
          title="eBills" 
          description="Get the convenience of online statements and reminders with eBills." 
          buttonText="Get eBills"
          buttonClick={ () => navigate(`/requestEBillWorkflow/${ biller.id }`, { "state" : { "goBack" : true } }) } 
          showNotice={ false }
          showeBillList={ false } 
          eBillListBills={ bills }
          showActiveUpsellNotice={ false }
          showActiveBadge={ false }
          dataPoint="Biller_Details_Get_Ebill" /> }
    
      { showActiveEBill &&
        <BillerDetailsUpsellView 
          className="active-ebill"
          icon={ <SVGAsset id="EbillsIcon" className="upsell-icon" /> } 
          title="eBills" 
          description={ `You're getting eBills from ${ billerName } ${ billerNumber }` }
          buttonText="Edit" 
          buttonClick={ () => navigate(`/turnOffEBill/${ biller.id }`, { "state" : { "goBack" : true } }) }
          showNotice={ false }
          showeBillList={ true }
          eBillListBills={ bills }
          showActiveUpsellNotice={ true } 
          showActiveBadge={ true }
          dataPoint="Biller_Details_Active_Ebills" /> }

    </div>
  );
}